declare var swal: any;
import { Component, OnInit, Input } from '@angular/core';
//import * as Chartist from 'chartist';
//import { ChartType, ChartEvent } from "ng-chartist/dist/chartist.component";

import { Router, ActivatedRoute } from '@angular/router';




declare var require: any;


import { NgbModal, NgbDateStruct, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';

import { routerTransition } from '../../../../../../src/app/ncs/animations/router.animations';
import { NgbAddBill } from './modal/addbill.modal';
import { NgbSearchPatientModal } from '../follow up/counsellingregistry/modal/searchpatient.modal';
import { BillDetailsInfoController, x_BillDetailsRequest, X_BillHeaderController, X_BillItemsController, X_BillReceiptsController, VendorInvoiceListController, VendorInvoiceListRequest, VendorInvoiceDetailsController, VendorInvoiceDetailsRequest, VendorInvoiceDetailsInfoController } from '../../../models/actor/actor';
import { AppData } from '../../../models/appdata';
import { ActorService } from '../../../services/actor.service';
import * as alertFunctions from '../../../../shared/data/sweet-alerts';
import { ApiResponseModel } from '../../../models/api_response_model';
import { SpinnerService } from '../../../services/spinner.service';
//import { billingpipe } from '../../../pipes/actors/actorIdentity.pipes';
//import { Pipe } from '@angular/core';
//import { Injectable } from '@angular/core';
//import { PipeTransform } from '@angular/core';
import { BillingPipe } from '../../../pipes/actors/actorIdentity.pipes';
import { PrintService } from '../../../../../../src/app/ncs/services/print.service';
import { NgbPaymentModeChangeModal } from './modal/paymentmodechange.modal';
import { NgbSearchPurchaseOrdersModal } from './modal/searchpurchaseorders.modal';



@Component({
  selector: 'materialinvoice',
  templateUrl: './materialinvoice.component.html',
  styleUrls: [
    './materialinvoice.component.scss']
  , animations: [routerTransition()]
})

export class MaterialInvoiceComponent implements OnInit {

  public ApiResData: ApiResponseModel;
  public isRequesting: boolean = false;
  public billdetails1: boolean = false;
  public billdetails2: boolean = false;
  public searchValue: string;
  searchTitle: string;
  minDate: NgbDateStruct;
  maxDate: NgbDateStruct;
  TodayDate = new Date();
  SelectedFromDate: NgbDateStruct;

  CurrentVendorInvoiceListController: VendorInvoiceListController[];
  CurrentVendorInvoiceHeaderDetailsController: VendorInvoiceListController;
  CurrentVendorInvoiceListRequest: VendorInvoiceListRequest;

  LoadInvoiceList() {
    this.CurrentVendorInvoiceListRequest = new VendorInvoiceListRequest();
    this.CurrentVendorInvoiceListRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetVendorInvoiceListController();
  }
  GetVendorInvoiceListController() {
    this.StartRefreshing();
    this.CurrentVendorInvoiceListRequest.FacilityCode = AppData.Instance().SelectedBranchCode;
    this.CurrentVendorInvoiceListRequest.FromDate = new Date();
    this.CurrentVendorInvoiceListRequest.ToDate = new Date();
    this.CurrentVendorInvoiceListRequest.InvoiceCode = 0;
    this.CurrentVendorInvoiceListRequest.ConditionalOperator = 10;
    this.actorservice.GetVendorInvoiceListController(this.CurrentVendorInvoiceListRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          this.CurrentVendorInvoiceListController = this.ApiResData.Result;
          this.stopRefreshing();
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }
  CurrentVendorInvoiceDetailsController: VendorInvoiceDetailsController[];
  CurrentVendorInvoiceDetailsRequest: VendorInvoiceDetailsRequest;
  VendorOrderDataHeader: VendorInvoiceDetailsInfoController;

  LoadInvoiceDetails() {
    this.CurrentVendorInvoiceDetailsRequest = new VendorInvoiceDetailsRequest();
    this.CurrentVendorInvoiceDetailsRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetVendorInvoiceDetailsController();
  }
  GetVendorInvoiceDetailsController() {
    this.StartRefreshing();
    this.CurrentVendorInvoiceDetailsRequest.Invoice = this.SelectedOrderdetails.DocID;
    this.CurrentVendorInvoiceDetailsRequest.ConditionalOperator = 10;
    this.actorservice.GetVendorInvoiceDetailsController(this.CurrentVendorInvoiceDetailsRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          this.VendorOrderDataHeader = this.ApiResData.Result;
          this.CurrentVendorInvoiceDetailsController = this.VendorOrderDataHeader.InvoiceItems;
          this.CurrentVendorInvoiceHeaderDetailsController = this.VendorOrderDataHeader.InvoiceHeader;
          this.stopRefreshing();
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }

  constructor(private router: Router,
    public printService: PrintService,
    private modalService: NgbModal,
    private actorservice: ActorService,
    private route: ActivatedRoute,
    private loaderService: SpinnerService,
    private parserFormatter: NgbDateParserFormatter,
    private filter: BillingPipe

    ,
  ) { }

  ngOnInit() {

    this.SelectedFromDate = { year: this.TodayDate.getFullYear(), month: this.TodayDate.getMonth() + 1, day: this.TodayDate.getDate() };
    this.LoadInvoiceList();
  }
  SelectedOrderdetails: VendorInvoiceListController;
  SelectedOrder(objCategory: any) {
    var Order: VendorInvoiceListController = objCategory;
    if (Order != null) {
      this.SelectedOrderdetails = null;
      this.SelectedOrderdetails = Order;
      this.billdetails1 = true;
      this.LoadInvoiceDetails();
    }
  }
  dataChanged(newobj) {

    this._GetVendorInvoiceListController()
  }
  _GetVendorInvoiceListController() {
    this.StartRefreshing();
    this.CurrentVendorInvoiceListRequest.FacilityCode = AppData.Instance().SelectedBranchCode;
    this.CurrentVendorInvoiceListRequest.FromDate = new Date(this.parserFormatter.format(this.SelectedFromDate));
    this.CurrentVendorInvoiceListRequest.ToDate = new Date(this.parserFormatter.format(this.SelectedFromDate));
    //this.CurrentPurchaseIndentsListRequest.PurchaseIndentCode = 0;
    this.CurrentVendorInvoiceListRequest.ConditionalOperator = 10;
    this.actorservice.GetVendorInvoiceListController(this.CurrentVendorInvoiceListRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          this.CurrentVendorInvoiceListController = this.ApiResData.Result;
          //this.pdata = this.CurrentPurchaseIndentsListControllernew;
          this.stopRefreshing();
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }
  DecrementDate() {

    var monthNo = this.SelectedFromDate.month
    var d: Date = new Date(
      this.SelectedFromDate.year,
      monthNo - 1,
      this.SelectedFromDate.day
    );
    d = new Date((new Date(d)).getTime() - (60 * 60 * 24 * 1000));
    this.SelectedFromDate = { year: d.getFullYear(), month: d.getMonth() + 1, day: d.getDate() };
    this._GetVendorInvoiceListController();
  }
  IncrementDate() {

    var monthNo = this.SelectedFromDate.month
    var d: Date = new Date(
      this.SelectedFromDate.year,
      monthNo - 1,
      this.SelectedFromDate.day
    );
    d = new Date((new Date(d)).getTime() + (60 * 60 * 24 * 1000));
    this.SelectedFromDate = { year: d.getFullYear(), month: d.getMonth() + 1, day: d.getDate() };
    this._GetVendorInvoiceListController();
  }
  //AddInvoice() {
  //  this.router.navigate(['healins/invoicereceipt']);
  //}
  AddInvoice() {
    const modalRef = this.modalService.open(NgbSearchPurchaseOrdersModal,
      {
        centered: true,
        size: 'lg',
        backdrop: 'static',
        keyboard: false
      })
    //this.router.navigate(['healins/purchaseorderadd']);
  }
  //Invoiceedit() {
  //  this.router.navigate(['healins/invoicereceiptedit', {
  //    DocIDData: this.SelectedOrderdetails.DocID
  //  }]);
  //}
  Invoiceedit() {
    this.router.navigate(['healins/invoiceedit_disc', {
      DocIDData: this.SelectedOrderdetails.DocID
    }]);
  }

  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }

  header() {
    let m = document.querySelector("#header");
    if (m) {
      m.scrollIntoView({ block: "center", inline: "nearest" });
    }
  }
  items() {
    let m = document.querySelector("#items");
    if (m) {
      m.scrollIntoView({ block: "center", inline: "nearest" });
    }
  }
  Receipts() {
    let m = document.querySelector("#Receipts");
    if (m) {
      m.scrollIntoView({ block: "center", inline: "nearest" });
    }
  }
  billedit() {
    this.router.navigate(['healins/invoicereceipt']);
  }

}
